import _regeneratorRuntime from "babel-runtime/regenerator";

var handleNativeFileDrop = function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(monitor, component) {
    var item, assetFilterWithUploader, sourceClientOffset, targetBoundingRect, newAsset, imageSize, video, positionX, positionY;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            component.setState({
              isUploadingImage: true
            });
            item = monitor.getItem().files[0];

            if (item) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            if (!(item.type.substr(0, 5) !== "image")) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            assetFilterWithUploader = (component.props.EditorContext.state.assets.assetsFilters || []).find(function (filter) {
              return filter.uploadAssets;
            });

            if (assetFilterWithUploader) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            sourceClientOffset = monitor.getClientOffset();
            targetBoundingRect = component.wrapper.getBoundingClientRect();
            _context.next = 13;
            return assetFilterWithUploader.uploadAssets([item]);

          case 13:
            newAsset = _context.sent;
            _context.next = 16;
            return getImageFileSize(item);

          case 16:
            imageSize = _context.sent;
            component.setState({
              isUploadingImage: false
            });
            video = component.props.EditorContext.state.video;
            positionX = Math.max(sourceClientOffset.x - targetBoundingRect.x - imageSize.width * video.scale / 2, 0);
            positionY = Math.max(sourceClientOffset.y - targetBoundingRect.y - imageSize.height * video.scale, 0);
            component.addImage(newAsset, positionX / video.scale, positionY / video.scale);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function handleNativeFileDrop(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Specifies the drop target contract.
 * All methods are optional.
 */


function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { DropTarget } from "react-dnd";
import * as OverlayContext from "../OverlayContext";
import * as EditorContext from "../EditorContext";
import ProcessingModal from "../../Misc/ProcessingModal";
import Canvas from "./Canvas";

var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    var _temp, _this, _ret;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.initializeCanvas = function (canvas) {
      _this.canvas = canvas;
    }, _this.addImage = function (url, x, y) {
      var OverlayContext = _this.props.OverlayContext;
      OverlayContext.editItemTimeSettings(null, function (start, duration) {
        return _this.canvas.addImage(url, x, y, start, duration);
      });
    }, _this.handleKeyDownEvent = function (e) {
      if ([8, 46].includes(e.keyCode)) {
        _this.canvas.deleteSelectedObjects();
      }
    }, _this.handleOverlayChanged = function (overlayData) {
      return _this.props.OverlayContext.setOverlay(overlayData);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Overlay.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        connectDropTarget = _props.connectDropTarget,
        selectedFrame = _props.selectedFrame;
    var backgroundUrl = selectedFrame ? selectedFrame.url : null;
    var isUploadingImage = !!(this.state || {}).isUploadingImage;
    return connectDropTarget(React.createElement("div", {
      ref: function ref(node) {
        return _this2.wrapper = node;
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      tabIndex: 1,
      onKeyDown: this.handleKeyDownEvent,
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      style: selectedFrame ? {
        backgroundImage: "url(" + backgroundUrl + ")",
        backgroundSize: "100% 100%"
      } : null
    }, ReactDOM.createPortal(React.createElement(ProcessingModal, {
      active: isUploadingImage,
      title: "Uploading image",
      text: "Please wait few seconds until finished."
    }), window.document.body), React.createElement(Canvas, {
      refCallback: this.initializeCanvas,
      overlayChangedHandler: this.handleOverlayChanged
    })));
  };

  return Overlay;
}(Component);

Overlay.propTypes = process.env.NODE_ENV !== "production" ? {
  selectedFrame: PropTypes.object,
  connectDropTarget: PropTypes.func.isRequired,
  OverlayContext: PropTypes.object.isRequired,
  EditorContext: PropTypes.object.isRequired
} : {};

function scaleTo(_ref, size) {
  var width = _ref.width,
      height = _ref.height;

  if (width < size && height < size) {
    return;
  }

  var scale = 175 / (width > height ? width : height);
  return {
    width: width * scale,
    height: height * scale
  };
}

function getImageFileSize(imageFile) {
  return new Promise(function (resolve) {
    var reader = new FileReader();

    reader.onload = function () {
      var img = new Image();

      img.onload = function () {
        return resolve(scaleTo({
          width: img.width,
          height: img.height
        }, 175));
      };

      img.src = reader.result;
    };

    reader.readAsDataURL(imageFile);
  });
}

var target = {
  drop: function drop(props, monitor, component) {
    var item = monitor.getItem();

    if (!item.url) {
      // assume the file dropped
      handleNativeFileDrop(monitor, component);
      return;
    }

    var sourceClientOffset = monitor.getSourceClientOffset();
    var targetBoundingRect = component.wrapper.getBoundingClientRect();
    var positionX = Math.max(sourceClientOffset.x - targetBoundingRect.x, 0);
    var positionY = Math.max(sourceClientOffset.y - targetBoundingRect.y, 0);
    var video = component.props.EditorContext.state.video;
    component.addImage(item.url, positionX / video.scale, positionY / video.scale);
  }
};
/**
 * Specifies which props to inject into your component.
 */

function collect(connect, monitor) {
  return {
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDropTarget: connect.dropTarget(),
    // You can ask the monitor about the current drag state:
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({
      shallow: true
    }),
    canDrop: true,
    itemType: monitor.getItemType()
  };
}

export default OverlayContext.consumeContext(EditorContext.consumeContext(DropTarget(["GraphicAsset", "__NATIVE_FILE__"], target, collect)(Overlay)));